import { atom } from "jotai";
import { getQuestionInfo, getStudentList } from "../../question";
import moment from "moment";
import { atomFamily, atomWithDefault } from "jotai/utils";

import { useAtomValue, useSetAtom } from "jotai";

export const questionnaireIdAtom = atom(0);
export const statusFilterAtom = atom("all");

export const sorterAtom = atom<any>({
    field: "",
    order: "ascend"
});

// 基础数据
export const getStudentListAtom = atomWithDefault(async get => {
    const questionnaireId = get(questionnaireIdAtom);
    return await getStudentList(questionnaireId);
});

// 刷新列表数据
export function useUpdateMarkList() {
    const questionnaireId = useAtomValue(questionnaireIdAtom);
    const updateMarkList = useSetAtom(getStudentListAtom);

    return async () => {
        const data = await getStudentList(questionnaireId);
        updateMarkList(data);
    };
}

// 状态过滤过的数据
export const filteredMarkList = atom(get => {
    const filter = get(statusFilterAtom);
    const markList = get(getStudentListAtom);

    return markList.list.filter((item: any) => {
        if (filter === "all") return true;
        if (filter === "joinCount") return item.joinStatus === "1";
        if (filter === "noJoinCount") return item.joinStatus === "0";
    });
});

// 过滤并且排序过的数据
export const filterAndSortMarkList = atom(get => {
    const markList = get(filteredMarkList);
    const sort = get(sorterAtom);

    if (sort.field === "submitTime" && sort.order) {
        const newList = [
            ...markList.sort((a: any, b: any) => {
                a = a.submitTime === null ? 0 : a.submitTime;
                b = b.submitTime === null ? 0 : b.submitTime;
                return moment(a).diff(b);
            })
        ];

        return sort.order === "ascend" ? newList : newList.reverse();
    }

    if (sort.field && sort.order) {
        const newList = [
            ...markList.sort((itemA: any, itemB: any) =>
                Number(itemA[sort.field]) > Number(itemB[sort.field]) ? 1 : -1
            )
        ];
        return sort.order === "ascend" ? newList : newList.reverse();
    }

    return markList;
});

// 学生列表
export const joinedStudentsAtom = atom(get => {
    const markList = get(filterAndSortMarkList);

    return markList
        .filter(item => item.joinStatus === "1")
        .map(item => ({
            studentNo: item.studentNo,
            studentName: item.name
        }));
});

// 根据学生id获取学生信息
export const currentStudentAtom = atomFamily((studentNo: string) => {
    return atom(get =>
        get(getStudentListAtom).list.find(item => item.studentNo === studentNo)
    );
});

// 练习信息
export const exerciseInfoAtom = atom(async get => {
    const questionnaireId = get(questionnaireIdAtom);
    return await getQuestionInfo({ questionnaireId });
});
